'use strict';

var GRADIENT_VARIANTS = {
  'LinearGradient': 'linear-gradient',
  'WebkitLinearGradient': '-webkit-linear-gradient',
  'WebkitGradient': '-webkit-gradient',
  'MozLinearGradient': '-moz-linear-gradient',
  'msLinearGradient': '-ms-linear-gradient'
};

var test = function (topColor, bottomColor) {
  if (typeof document === 'undefined') {
    console.log('document unavailable in node');
    return;
  }

  var testEl = document.createElement('div'),
      style = testEl.style;

  for (var gradientName in GRADIENT_VARIANTS) {
    var prefixedString = GRADIENT_VARIANTS[gradientName],
        gradient = '',
        templateString = '';

    style.backgroundImage = '';

    if (gradientName === 'LinearGradient') {
      gradient = prefixedString + '(to bottom,' + topColor + ',' + bottomColor + ')';
      templateString = prefixedString + '(to bottom, %topColor%, %bottomColor%)';
    } else if (gradientName === 'WebkitGradient') {
      gradient = prefixedString + '(linear,' + topColor + ',' + bottomColor + ')';
      templateString = prefixedString + '(linear, %topColor%, %bottomColor%)';
    } else {
      gradient = prefixedString + '(top,' + topColor + ',' + bottomColor + ')';
      templateString = prefixedString + '(top, %topColor%, %bottomColor%)';
    }

    style.backgroundImage = gradient;

    if (style.backgroundImage.length) {
      test.templateString = templateString;
      return gradient;
    }
  }
};

var gradient = function (topColor, bottomColor) {
  if (!test.templateString) {
    test(topColor, bottomColor);
  }

  return test.templateString.replace('%topColor%', topColor).replace('%bottomColor%', bottomColor);
};

module.exports = gradient;



/** WEBPACK FOOTER **
 ** ./utils/gradient.js
 **/